<template>
  <ItemDetailEditor mode="EDIT"/>
</template>

<script>

import ItemDetailEditor from '@/components/ItemDetailEditor';

export default {
  components: {
    ItemDetailEditor
  }
}
</script>

<style scoped></style>